import React from 'react';

const About = () => {
    return (
        <div className="">
            <h3 className="font-bold mt-8 text-"> Product Details </h3>
       <div className="m-5 p-5 rounded shadow-lg">
            <h3 className="font-bold"> Processor:</h3>
        <p>  Processor 12th Generation Intel® Core™ i7-12700H (24MB Cache, up to 4.7 GHz, 14 cores)</p>
        <h3 className="font-bold">Operating System:</h3>
        <p>Windows 11 Home, English</p>
        <h3 className="font-bold">Graphics Card :</h3>
        <p>NVIDIA® GeForce RTX™ 3050 Ti, 4 GB GDDR6, 45 W</p>
        <h3 className="font-bold">Display :</h3>
        <p>15.6", 3.5K 3456x2160, 60Hz, OLED, Touch, Anti-Reflect, 400 nit, InfinityEdge</p>
        <h3 className="font-bold"> Memory :</h3>
        <p> 16 GB, 2 x 8 GB, DDR5, 4800 MHz, dual-channel </p>
        <h3 className="font-bold"> Hard Drive :</h3>
        <p>1 TB, M.2, PCIe NVMe, SSD</p>
        <h3 className="font-bold"> Camera :</h3>
        <p> 720p at 30 fps, HD camera Dual-array microphones</p>
        <h3 className="font-bold">Audio and Speakers:</h3>
        <p>Stereo woofer 2.5 W x 2 and stereo tweeter 1.5 W x 2 = 8 W total peak</p>
        <h3 className="font-bold"> Primary Battery :</h3>
        <p>6 Cell, 86 Wh, integrated</p>
</div>     
        </div>
    );
};

export default About;